<div
  class="ui vertical segment"
  [ngClass]="{ loading: pending }"
  appPadding="0"
>
  <div
    id="no-radius"
    fxLayout="row"
    tamsyMargin
    class="ui basic segment"
    marginB="3"
    fxLayoutGap="10px"
    fxLayoutAlign="start stretch"
  >
    <div fxFlex="20%">
      <div
        *ngIf="
          file.fileSettingsId === 'file_upload_response';
          else notFileUpload
        "
      >
        Scenario
      </div>

      <ng-template #notFileUpload>File Type</ng-template>
    </div>

    <div
      fxFlex="grow"
      *ngIf="file.fileSettingsId === 'file_size_configuration'"
    >
      Maximum Size (in Bytes)
    </div>

    <div fxFlex="grow" *ngIf="file.fileSettingsId === 'file_upload_response'">
      Feedback
    </div>

    <div fxFlex="grow" *ngIf="file.fileSettingsId === 'allowed_file_types'">
      Extension
    </div>

    <div fxFlex="15%">Date Modified</div>

    <div fxFlex="15%">Modified By</div>

    <div fxFlex="25%"></div>
  </div>
  <div
    class="ui basic segment"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="15px"
    *ngFor="let unit of settings"
  >
    <div fxFlex="20%">{{ unit?.key }}</div>

    <div fxFlex="grow">
      {{ unit?.value }}
    </div>

    <div fxFlex="15%">{{ unit.dateModified | date }}</div>

    <div fxFlex="15%">{{ unit?.modifiedBy | createdBy }}</div>

    <div fxFlex="25%" class="text-right" fxLayoutGap="10px">
      <!-- &nbsp; -->
    </div>
  </div>
  <app-no-record-found
    *ngIf="!settings || settings.length < 1"
  ></app-no-record-found>
</div>
